import _ from "lodash";
import Transaction from "models/Transaction";
import SelectedDates from "utilities/dates/SelectedDates";

export default class TransactionCollection {
	constructor() {
		this.transactions = new Map();
		this.monthsThatHaveBeenRetrieved = {};
		this.clearCache();
	}

	clearCache() {
		this.cachedByMonthResults = {};
		this.cachedAllResults = null;
		// this.monthsThatHaveBeenRetrieved = {};
	}

	/**
	 * @param dates
	 * @returns {[]}
	 */
	byDates(dates) {
		if(!dates) {
			throw new Error('date is a required parameter');
		}
		const allTransactions = [];
		SelectedDates.loop(dates, (date) => {
			allTransactions.push(...this.byMonth(date.year(), date.month()));
		});
		return allTransactions;
	}

	byMonth(year, month) {
		if(this.cachedByMonthResults?.[year]?.[month]) {
			return this.cachedByMonthResults[year][month];
		} else {
			if(!this.cachedByMonthResults[year]) {
				this.cachedByMonthResults[year] = {};
			}
			if(!this.cachedByMonthResults[year][month]) {

			}
		}
		const transactions = [];
		this.toArray().map((transaction) => {
			if(transaction.month === month && transaction.year === year) {
				transactions.push(transaction);
			}
		});
		transactions.sort(Transaction.transactionSort);
		return this.cachedByMonthResults[year][month] = transactions;
	}

	addTransaction(transaction) {
		this.clearCache();
		const key = this._getTransactionListKeyFromTransaction(transaction);
		this.transactions.set(key, transaction);
	}

	removeTransaction(transaction) {
		this.clearCache();
		const key = this._getTransactionListKeyFromTransaction(transaction);
		this.transactions.delete(key);
	}

	retrieveSimilarTransactionByKey(transaction) {
		const transactionListKey = this._getTransactionListKeyFromTransaction(transaction);
		return this.transactions.get(transactionListKey);
	}

	getTransactionById(id) {
		return this.transactions.get(id);
	}

	_getTransactionListKeyFromTransaction(transaction) {
		if(transaction.id) {
			return `id-${transaction.id}`;
		} else if(transaction.submit_id) {
			return `temp-${transaction.submit_id}`;
		} else {
			console.error(transaction);
			throw new Error('transaction has no id or submit id');
		}
	}

	toArray() {
		if(this.cachedAllResults) {
			return this.cachedAllResults;
		}
		return this.cachedAllResults = Array.from(this.transactions).map(([key, value]) => value);
	}
}